export default {
  props: ['modelValue', 'readOnly'],
  beforeMount() {
    this.randomVid = Math.random() + ''
    if (this.modelValue) {
      this.emitModel(this.modelValue)
    } else {
      if (this.defaultValue) {
        this.emitModel(this.defaultValue)
        this.shouldUpdateValidator = true
      }
    }
  },
  mounted() {
    if (this.$refs.input && this.shouldUpdateValidator) {
      this.$refs.input.$refs.field.handleChange(this.modelValue, false)
    }
  },
  methods: {
    emitModel(value) {
      let castedVal = value
      if (this.fieldType == Number.name) {
        castedVal = value === null || value == '' ? null : +value
      }
      this.$emit('update:modelValue', castedVal)
    }
  },
  computed: {
    model: {
      get() {
        return this.modelValue
      },
      set(val) {
        this.emitModel(val)
      }
    },
    choices() {
      return this.$attrs.choices || this.$attrs?.options?.choices || []
    },
    validation() {
      return this.$attrs.validation || this.$attrs?.options?.validation || ''
    },
    defaultValue() {
      return this.$attrs.defaultValue || this.$attrs?.options?.defaultValue || null
    },
    placeholder() {
      return this.$attrs.placeholder || this.$attrs?.options?.placeholder || ''
    },
    rules() {
      let generatedRules = [];
      if (this.validation && !this.$attrs['is-preview']) {
        for (const [rule, value] of Object.entries(this.validation)) {
          let newRule = '', intVal = parseInt(value)
          if (rule == 'isRequired' && value === true) {
            newRule = 'required'
          } else if (rule == 'minChars' && !isNaN(intVal)) {
            newRule = `min:${intVal}`
          } else if (rule == 'maxChars' && !isNaN(intVal)) {
            newRule = `max:${intVal}`
          } else if (['min_value', 'max_value'].includes(rule) && !isNaN(intVal)) {
            newRule = `${rule}:${intVal}`
          }
          generatedRules.push(newRule)
        }
        return generatedRules.join('|')
      } else {
        return ''
      }
    }
  },
  data() {
    return {
      randomVid: '',
      shouldUpdateValidator: false,
      fieldType: null
    }
  },
  watch: {
    modelValue: {
      handler(newVal) {
        if (this.$refs.input) {
          this.$refs.input.$refs.field.handleChange(newVal)
        }
        this.$emit('update:modelValue', newVal)
      },
      immediate: true,
      deep: true
    }
  }
}
